/* All Ranges mega menu (snippets/fi-mega-ranges.liquid): "Show more" opens the
   hidden tiles, then gives way to the "View all ranges" link. */
(function () {
  if (document.documentElement.hasAttribute('data-fi-mr-js')) return;
  document.documentElement.setAttribute('data-fi-mr-js', '');

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-fi-mr-show]');
    if (!button) return;
    var root = button.closest('[data-fi-mr]');
    if (!root) return;
    event.preventDefault();

    var more = root.querySelectorAll('[data-fi-mr-more]');
    Array.prototype.forEach.call(more, function (item) {
      item.hidden = false;
    });
    var all = root.querySelector('[data-fi-mr-all]');
    button.hidden = true;
    if (all) {
      all.hidden = false;
      all.focus();
    } else if (more[0]) {
      var link = more[0].querySelector('a');
      if (link) link.focus();
    }
  });
})();
